// extracted by mini-css-extract-plugin
module.exports = {"Game":"Game_Game__2qp9N","Info":"Game_Info__3l3Qa","Directions":"Game_Directions__risiM"};